import { render, staticRenderFns } from "./FollowService.vue?vue&type=template&id=6b94aad4&scoped=true"
import script from "./FollowService.vue?vue&type=script&lang=js"
export * from "./FollowService.vue?vue&type=script&lang=js"
import style0 from "./FollowService.vue?vue&type=style&index=0&id=6b94aad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b94aad4",
  null
  
)

export default component.exports